/**
 * FeatureStatusBadge — audit-remediation Phase 1.
 *
 * The SEO audit flagged that FoodPulse conflates aspirational and shipped
 * features throughout the site — "comprehensive nutrition analysis" appears
 * next to a database with 6 indexed products. This tiny pill component
 * gives every ambitious page an honest status label so users (and search
 * crawlers) can distinguish beta from GA.
 *
 * Usage:
 *   <FeatureStatusBadge status="beta" />
 *   <FeatureStatusBadge status="growing" note="6 products · 6 brands" />
 *   <FeatureStatusBadge status="planned" />
 */
const VARIANTS = {
  live: {
    label: "Available now",
    bg: "#DCFCE7", fg: "#166534", ring: "#86EFAC",
  },
  beta: {
    label: "Limited beta",
    bg: "#FEF3C7", fg: "#92400E", ring: "#FCD34D",
  },
  growing: {
    label: "Growing database",
    bg: "#DBEAFE", fg: "#1E40AF", ring: "#93C5FD",
  },
  needs_contribution: {
    label: "Community contribution needed",
    bg: "#EDE9FE", fg: "#5B21B6", ring: "#C4B5FD",
  },
  planned: {
    label: "Planned",
    bg: "#F1F5F9", fg: "#475569", ring: "#CBD5E1",
  },
};

export default function FeatureStatusBadge({
  status = "live",
  note,
  className = "",
  testid,
}) {
  const v = VARIANTS[status] || VARIANTS.live;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-mono uppercase tracking-wider ring-1 ${className}`}
      style={{ background: v.bg, color: v.fg, borderColor: v.ring, boxShadow: `inset 0 0 0 1px ${v.ring}` }}
      data-testid={testid || `feature-status-${status}`}
      title={v.label}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ background: v.fg }} />
      {v.label}
      {note && <span className="normal-case tracking-normal opacity-80">· {note}</span>}
    </span>
  );
}
